import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styled from 'styled-components';
import { sortBy } from 'lodash';
import TypeAheadDropdown from 'components/Global/Fields/TypeAheadDropdown.jsx';
import { getAllCompanies } from "store/state/companies";
import { compose } from "recompose";
import { connect } from "react-redux";
import { updateContact } from "store/state/contacts";
import { changeCompanyForContactBanner } from "store/state/companies";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { ChevronLeft } from "@material-ui/icons";
import _ from "lodash";

const Banner = styled.div`
    height: 40px;
    background-color: #005AA9;
    color: #ffffff;
    width: 1120px;
    margin: auto;
`

const SmallBanner = styled.div`
    height: 24px;
    background-color: #005AA9;
    color: #ffffff;
    width: 1120px;
    margin: 0;
`

const BannerText = styled.div`
    margin-right: 20px;
    margin-top: 8px;
    color: white;
    font-size: 16px;
    display:inline-block;
`

const SmallBannerText = styled.div`
    margin-right: 20px;
    color: white;
    font-size: 16px;
    display:inline-block;
`
const CompanyDropdown = styled(TypeAheadDropdown)`
    color: black;
    width: 400px;
    border: none;
    font-size: 14px;
    height: 25px;
    display:inline-block;
    position: absolute;
`;

const DropdownContainerDiv = styled.div`
  display:inline-block;
`
const CollapsedExpansionButton = styled.button`
    float:left;
    height:20px;
    width:40px;
    background-color: #005AA9;
    border:0px solid black;
    margin: auto;
`
const ExpandedExpansionButton = styled.button`
    float:left;
    height:40px;
    width:40px;
    background-color: #005AA9;
    border:0px solid black;
    margin: auto;
`
const StyledFormControlLabel = styled(FormControlLabel)`&&&&&&&{
    float:right;
    margin-right: 16px;
    color: white;
}`

const StyledCheckbox = styled(Checkbox)`&&&&{
    color: white;
}`

const ChevronUp = styled(ChevronLeft)`
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    transform: rotate(-90deg);
    color:white;
`;

const ChevronDown = styled(ChevronLeft)`
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
    color:white;
`;

const StyledContainer = styled(Banner)`
  margin: auto;
`
const WhiteText = styled.span`
    color: white;
`;

class ViewAsBanner extends Component {

    findUsersCompanyOption = () => {
        if (this.props.companies && this.props.authentication) {
            return _.find(this.props.companies, (item) => {
                return item.id === this.props.authentication.user.contact.companyId;
            }, 0);
        } else {
            return null;
        }
    }

    state = {
        viewAsCompany: null,
        defaultValue: null,
        expanded: false,
        onlyActive: true,
    };

    componentDidMount() {
        this.props.getAllCompanies({ activeOnly: this.state.onlyActive });
    }

    componentDidUpdate(prevProps) {
        if (this.props.shouldRefresh) {
            window.location.reload();
        }
    }

    renderExpansionButton = () => {
        return this.state.expanded ?
            (<ExpandedExpansionButton id="company-select-button" onClick={this.handleExpansionButtonClick}>{this.renderChevron()}</ExpandedExpansionButton>)
            :
            (<CollapsedExpansionButton id="company-select-button" onClick={this.handleExpansionButtonClick}>{this.renderChevron()}</CollapsedExpansionButton>)
    }
    renderCheckBox = () => {
        return (<StyledFormControlLabel
            control={
                <StyledCheckbox
                    checked={this.state.onlyActive}
                    onChange={this.handleChange('onlyActive')}
                    value="onlyActive"
                />
            }
            label={(<WhiteText>Show Only Active Companies</WhiteText>)}
        />)
    }

    renderChevron = () => this.state.expanded ? <ChevronDown /> : <ChevronUp />;

    renderMinimizedRibbon = () => {
        return (
            <SmallBanner id='CurrentUserCompanyDropdown'>
                {this.renderExpansionButton()}
                <SmallBannerText>Current User Company: {this.findUsersCompanyOption()?.label}</SmallBannerText>
            </SmallBanner>
        );
    };

    handleExpansionButtonClick = () => {
        this.setState({ expanded: !this.state.expanded })
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
        this.props.getAllCompanies({ activeOnly: event.target.checked });
    };
    render() {
        for (let i = 0; i < this.props.companies.length; i++) {
            this.props.companies[i].label = this.props.companies[i].name;
        }

        if (!this.props.authentication || !this.props.authentication.isSystemAdmin || !this.props.companies || this.props.companies.length == 0) {
            return null;
        }

        if (!this.state.expanded) {
            return this.renderMinimizedRibbon();
        }

        const companies = sortBy(this.props.companies, "name");
        return (
            <StyledContainer>
                <Banner>
                    <BannerText>
                        Change User Company:
                    </BannerText>
                    <DropdownContainerDiv>
                        <CompanyDropdown
                            name="CompanySelection"
                            placeholder="Company"
                            options={companies}
                            usingFormik={false}
                            shouldShow={true}
                            label="CompanySelection"
                            selectStyles={{
                                control: (provided, state) => ({ ...provided, boxShadow: 'none', border: 'none', padding: 0 }),
                                indicatorSeparator: (provided, state) => ({ ...provided, display: 'none' }),
                                container: (provided, state) => ({
                                    ...provided, width: '400px', backgroundColor: 'white', '&:hover': { cursor: 'pointer', borderBottom: '1px solid #21c1f2' },
                                    padding: '0',
                                    height: '34px',
                                    position: 'absolute',
                                    top: '63px'
                                }),
                            }}
                            handleChange={
                                data => {
                                    this.state.viewAsCompany = data;
                                    this.submit();
                                }
                            }
                            value={null} //for some reason I cannot change the value unless I declare it here
                            defaultValue={this.findUsersCompanyOption()}
                        />

                    </DropdownContainerDiv>
                    {this.renderExpansionButton()}
                    {this.renderCheckBox()}
                </Banner>
            </StyledContainer>

        )
    }

    submit = () => {
        const valuesToSubmit = { ...this.props.authentication.user.contact };
        valuesToSubmit.companyId = this.state.viewAsCompany.id;
        valuesToSubmit.companyOnly = true;
        this.props.changeCompanyForContactBanner({ companyId: this.state.viewAsCompany.id, callback: () => { this.props.history.push(`/DealsDashboard`) } });
    }

}

const mapStateToProps = ({ companies, authentication }) => ({
    companies: companies.allCompanies ? companies.allCompanies.companies : [],
    authentication: authentication,
    shouldRefresh: companies.shouldRefreshBanner
});

export default compose(
    withRouter,
    connect(
        mapStateToProps,
        { getAllCompanies, updateContact, changeCompanyForContactBanner }
    )
)(ViewAsBanner);